import { NgModule } from '@angular/core';
import {
	TranslateCompiler,
	TranslateModule,
} from '@ngx-translate/core';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';

import { CommonLocaleService } from './locale.service';
import { CommonTranslationCompiler } from './translation_compiler.service';
import { CommonTranslateParamsPipe } from './translate_params.pipe';

@NgModule({
	declarations: [
		CommonTranslateParamsPipe,
	],
	imports: [
		TranslateModule.forRoot({
			compiler: {
				provide: TranslateCompiler,
				useClass: CommonTranslationCompiler,
			},
		}),
	],
	exports: [
		CommonTranslateParamsPipe,
	],
	providers: [
		CommonLocaleService,
		CommonTranslateParamsPipe,
		TranslateMessageFormatCompiler,
	],
})
export class CommonLocaleModule {}
